module.exports = __webpack_public_path__ + "assets/img/time.effde070.png";